/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S3_Form_PreInputs */

const tr_iletisim_s3_form_pre = /** @type {(inputs: Iletisim_S3_Form_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başvurunuzu`)
};

const en_iletisim_s3_form_pre = /** @type {(inputs: Iletisim_S3_Form_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can also submit your request through the`)
};

const de_iletisim_s3_form_pre = /** @type {(inputs: Iletisim_S3_Form_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihren Antrag können Sie auch über das`)
};

const ru_iletisim_s3_form_pre = /** @type {(inputs: Iletisim_S3_Form_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Своё заявление вы также можете подать через`)
};

/**
* | output |
* | --- |
* | "You can also submit your request through the" |
*
* @param {Iletisim_S3_Form_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s3_form_pre = /** @type {((inputs?: Iletisim_S3_Form_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S3_Form_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s3_form_pre(inputs)
	if (locale === "de") return de_iletisim_s3_form_pre(inputs)
	if (locale === "ru") return ru_iletisim_s3_form_pre(inputs)
	return tr_iletisim_s3_form_pre(inputs)
});